module.exports = __webpack_public_path__ + "static/image/history/pc/202302@3x.jpg?e792f6f7";